import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { Row } from '../Row';
import { StyledListWrapper } from './List.styled';
import type { ListComponent, ListProps } from './List.types';

export const List: ListComponent = forwardRef(
  <C extends ElementType = 'div'>(
    { leftContent, rightContent, size = 'L', styledComponents, ...props }: ListProps<C>,
    ref: PolymorphicRef<C>,
  ) => {
    return (
      <StyledListWrapper
        justifyContent='space-between'
        ref={ref}
        size={size}
        {...props}
        {...styledComponents?.root}
      >
        <Row alignItems='center' gap={4}>
          {leftContent}
        </Row>
        <Row alignItems='center' gap={4}>
          {rightContent}
        </Row>
      </StyledListWrapper>
    );
  },
);
